import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import FeatureDetailRow from '../featureDetailRow';

const FeatureDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <FeatureDetailRow label={<IntlMessages id="label.description" />} description={displayData?.description} />
                    <FeatureDetailRow label={<IntlMessages id="label.priority" />} description={displayData?.priority} />
                    <FeatureDetailRow label={<IntlMessages id="feature.successIndicators" />} description={displayData?.succcessIndicators} />
                    <FeatureDetailRow label={<IntlMessages id="label.startDate" />} description={displayData?.startDate} />
                    <FeatureDetailRow label={<IntlMessages id="label.endDate" />} description={displayData?.endDate} />
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default FeatureDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/feature/featureDetail/featureDetailTable/index.js